import request from '@/utils/request'
// 获取表格数据
export const getTableData = data => request().post('assurance/task/page', data)
/**
 * 获取企业列表
 * @param data
 * @returns {*}
 */
/**
 * 下载附件
 * @param {*} data
 */
export const downloadAttachment = id => {
  return request().get(`assurance/download/${id}`, {
    responseType: 'blob',
  })
}

export const getCustomerList = data => request().get(`customer/list/${data}`)
/**
 * 申请信息
 * @param {*} data
 */
export const addAssurance = data => request().post('assurance/apply', data)
// 下载附件
export const downUpload = id => request().get(`assurance/download/${id}`)
// 申请pageMinea  getAssurance
export const agetAssurance = data =>
  request().post('assurance/apply/pageMine', data)
/**
 * 查询基本详情
 * @param {*} data
 */
export const queryBase = data => request().get(`bp/apply/queryBase/${data}`)

// doApprove審批通過與否
export const doApprove = data => request(false).post('assurance/approve', data)

// 獲取審批詳情
export const getAssuranceApply = bpmId =>
  request().get(`assurance/approve/detail/${bpmId}`)

/**
 * 获取子公司信息
 * @param {*} data
 */
export const getAllocateOverview = data =>
  request().post('creditLine/allocate/overview', data)
/**
 * 获取审批人列表
 */
export const getApprovePersons = () =>
  request().get('bp/batch/apply/listApprovePerson')
/**
 * 获取担保审批人列表
 */
export const getAssurancePersons = () =>
  request().get('assurance/apply/approves')
// ----------------------------限额分配管理页------------------------
// 担保有效值
export const IsListAssurance = ({ companyId, assuranceName, bookType }) =>
  request().get(
    `assurance/list/valid/${companyId}/${bookType}/${assuranceName}`,
  )
// 上传文件
export const uploadFile = data => request().post('assurance/upload', data)
// deleteFile
export const deleteFile = fileId =>
  request().get(`assurance/deleteFile/${fileId}`)
